import { queryOptions } from '@tanstack/react-query';

import { getIntegrationQueryKeys } from '@/entities/(integration)/integrations';
import { SOURCE_TYPE } from '@/types/feedbackConst';

import { getQualtricsInfo } from './get-qualtrics-info';

/**
 * Qualtrics queryKeys 팩토리
 */
export const qualtricsQueryKeys = {
  all: (workspaceAlias: string) =>
    getIntegrationQueryKeys(SOURCE_TYPE.QUALTRICS, workspaceAlias),
};

/**
 * Qualtrics 연동 정보 목록 조회 queryOptions
 */
export const qualtricsInfoQueryOptions = (
  workspaceAlias: string,
  options?: { enabled?: boolean },
) =>
  queryOptions({
    queryKey: qualtricsQueryKeys.all(workspaceAlias),
    queryFn: () => getQualtricsInfo({ workspace_id: workspaceAlias }),
    placeholderData: [],
    ...options,
  });
